/* eslint-disable @angular-eslint/directive-selector */
import {
  Directive,
  OnInit,
  TemplateRef,
} from "@angular/core";
import { NavigationMenuService } from "../../services/navigation-menu/navigation-menu.service";

export interface CallToActionLabel {
  label: string;
  icon: string;
}

@Directive({
  selector: "[callToAction]",
  standalone: true,
})
export class CtaDirective implements OnInit {
  constructor(
    private navigationMenu: NavigationMenuService,
    private template: TemplateRef<any>
  ) {}

  ngOnInit(): void {
    this.navigationMenu.cta.next(this.template);
  }
}
